const parseLogData = (logData) => {
  try {
    return typeof logData === "string" ? JSON.parse(logData) : logData;
  } catch (e) {
    console.error("Error parsing log_data:", e);
    return {};
  }
};

const extractLogDetails = (log) => {
  let appName = "N/A";
  let details = "N/A";

  try {
    const logData = parseLogData(log.log_data);

    switch (log.type) {
      case "screen":
        appName = logData?.meta_data?.app_name || "N/A";
        details = `Screen: ${logData?.screen_name || "N/A"}`;
        break;
      case "form":
        appName = logData?.app_name || "N/A";
        const formDuration = logData?.entry?.duration;
        const formDetails = `Sm Name: ${logData?.entry?.sm_name || "N/A"}`;
        details = formDuration ? `${formDetails} (${formDuration})` : formDetails;
        break;
      case "http":
        appName = logData?.app_name || "N/A";
        const httpStatus = logData?.http_status_code || logData?.entry?.data?.response?.status_code || "N/A";
        const httpMs = logData?.entry?.elapsed_ms || logData?.elapsed_ms;
        const httpDetails = `Status: ${httpStatus}`;
        details = httpMs ? `${httpDetails} (${httpMs}ms)` : httpDetails;
        break;
      case "activity":
        appName = logData?.app_name || "N/A";
        details = `Sm Name: ${logData?.entry?.sm_name || logData?.sm_name || "N/A"}`;
        break;
      default:
        appName = logData?.app_name || logData?.data?.app_name || "N/A";
    }
  } catch (e) {
    console.error("Error extracting log details:", e);
    return { appName: "N/A", details: "N/A" };
  }

  return { appName, details };
};

const getActiveFilters = (filters) => {
  return Object.entries(filters).reduce((acc, [key, value]) => {
    if (value) acc[key] = value;
    return acc;
  }, {});
};

export { parseLogData, extractLogDetails, getActiveFilters };
